import { PlanningUserSettingsType } from 'src/api/planning/types';

export const DEFAULT_PLANNING_SETTINGS_VALUES: PlanningUserSettingsType = {
  field: { columns: [] },
  rig: { columns: [] },
};
